import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DtpAccordionPanel, DtpAccordionGroup } from 'dtp-react-components';
import ProtectedItem from '../../components/ComponentesAutenticacao/ProtectedItem';
import { Input, Grid, Button } from '../../components';
import Masks from '../../utils/masks';
import {
  tipoParticipacao,
  tipoRequerimentoFilter,
  tiposEstado,
  tiposEstadoAnalise,
  tipoEntidade,
  tiposEstadoParecerMedico,
  prismaFilter,
  filaGetFilter,
  pendenteEnvio,
} from '../../utils/listsSelect';
import { trataMensagensErro } from '../../utils/requests';

const destinoRGPS = '01000';

class FiltroPesquisa extends Component {
  constructor() {
    super();

    this.filtroPesquisa = JSON.parse(sessionStorage.getItem('filtroPesquisa'));

    // tipoRequerimento: null,
    this.state = {
      cpf:
        this.filtroPesquisa && this.filtroPesquisa.cpf ?
          this.filtroPesquisa.cpf : null,
      nit:
        this.filtroPesquisa && this.filtroPesquisa.nit ?
          this.filtroPesquisa.nit : null,
      numeroBeneficio:
        this.filtroPesquisa && this.filtroPesquisa.numeroBeneficio ?
          this.filtroPesquisa.numeroBeneficio : null,
      tipoRequerimento:
        this.filtroPesquisa && this.filtroPesquisa.tipoRequerimento ?
          this.filtroPesquisa.tipoRequerimento : null,
      participacao:
        this.filtroPesquisa && this.filtroPesquisa.participacao ?
          this.filtroPesquisa.participacao : 1,
      estado:
        this.filtroPesquisa && this.filtroPesquisa.estado ?
          this.filtroPesquisa.estado : null,
      'destinatario-rpps':
        this.filtroPesquisa && this.filtroPesquisa['destinatario-rpps'] ?
          this.filtroPesquisa['destinatario-rpps'] : null,
      filtraExigenciaHomologacao:
        this.filtroPesquisa && this.filtroPesquisa.filtraExigenciaHomologacao ?
          this.filtroPesquisa.filtraExigenciaHomologacao : false,
      tipoEntidade:
        this.filtroPesquisa && this.filtroPesquisa.tipoEntidade ?
          this.filtroPesquisa.tipoEntidade : null,
      cliqueiNoBotao:
        this.filtroPesquisa && this.filtroPesquisa.cliqueiNoBotao ?
          this.filtroPesquisa.cliqueiNoBotao : 0,
      filtro:
        this.filtroPesquisa && this.filtroPesquisa.filtro ?
          this.filtroPesquisa.filtro : null,
      tipoFiltroFilaGet:
        this.filtroStorage && this.filtroStorage.tipoFiltroFilaGet ?
          this.filtroStorage.tipoFiltroFilaGet : null,
      tipoFiltroPrisma:
        this.filtroPesquisa && this.filtroPesquisa.tipoFiltroPrisma ?
          this.filtroPesquisa.tipoFiltroPrisma : null,
      mascara:
        this.filtroPesquisa && this.filtroPesquisa.mascara ?
          this.filtroPesquisa.mascara : '',
      dtPrismaInicio:
        this.filtroPesquisa && this.filtroPesquisa.dtPrismaInicio ?
          this.filtroPesquisa.dtPrismaInicio : null,
      dtPrismaFim:
        this.filtroPesquisa && this.filtroPesquisa.dtPrismaFim ?
          this.filtroPesquisa.dtPrismaFim : null,
      dtComprevInicio:
        this.filtroPesquisa && this.filtroPesquisa.dtComprevInicio ?
          this.filtroPesquisa.dtComprevInicio : null,
      dtComprevFim:
        this.filtroPesquisa && this.filtroPesquisa.dtComprevFim ?
          this.filtroPesquisa.dtComprevFim : null,
      especieBeneficio:
        this.filtroPesquisa && this.filtroPesquisa.especieBeneficio ?
          this.filtroPesquisa.especieBeneficio : null,
      tipoPesquisa:
        this.filtroPesquisa && this.filtroPesquisa.tipoPesquisa ?
          this.filtroPesquisa.tipoPesquisa : null,
      pendenteEnvio:
        this.filtroPesquisa && this.filtroPesquisa.pendenteEnvio ?
          this.filtroPesquisa.pendenteEnvio : null,
      mensagemRetorno:
        this.filtroPesquisa && this.filtroPesquisa.mensagemRetorno ?
          this.filtroPesquisa.mensagemRetorno : null,
      bodyEnvio:
        this.filtroPesquisa && this.filtroPesquisa.bodyEnvio ?
          this.filtroPesquisa.bodyEnvio : null,
    };
  }

  componentDidMount() {
    if (sessionStorage.getItem('filtroPesquisa') &&
      this.state.tipoPesquisa === this.getTipoConsulta()) {
      this.handleSearchButton();
    }
  }

  componentDidUpdate(prevProps) {
    // Apenas repete consulta se parametro da url for alterado
    if (this.props.tipoConsulta !== prevProps.tipoConsulta) {
      this.preparaNovaConsulta();
    } else if (this.props.tipoConsulta === 'exigencia' && this.props.listaRequerimentosIndexadaAtualizada) {
      this.handleListFilter();
    }
  }

  getTipoConsulta = () => (
    this.props.tipoConsulta ?
      this.props.tipoConsulta : 'consulta'
  )

  controleFiltrosAlternativos = (campo) => {
    switch (campo) {
      case 'destinatario-rpps':
        return ['requerer-compensacao-rgps', 'analisar-negocio-sprev', 'gerenciar-negocio-dcomp', 'auditar-comprev'];
      default:
        return [];
    }
  }

  preparaNovaConsulta = () => {
    let filtroPesquisa = {
      cpf: null,
      nit: null,
      numeroBeneficio: null,
      tipoRequerimento: null,
      participacao: 1,
      estado: null,
      'destinatario-rpps': null,
      filtraExigenciaHomologacao: false,
      tipoEntidade: null,
      cliqueiNoBotao: 0,
      filtro: null,
      tipoFiltroFilaGet: null,
      tipoFiltroPrisma: null,
      mascara: '',
      dtPrismaInicio: null,
      dtPrismaFim: null,
      dtComprevInicio: null,
      dtComprevFim: null,
      especieBeneficio: null,
      tipoPesquisa: this.getTipoConsulta(),
    };
    filtroPesquisa = JSON.stringify(filtroPesquisa);
    sessionStorage.setItem('filtroPesquisa', filtroPesquisa);

    this.setState({
      cpf: null,
      tipoRequerimento: null,
      participacao: 1,
      'destinatario-rpps': null,
      filtraExigenciaHomologacao: false,
      tipoEntidade: null,
    });
  }

  handleChange = (changeObj, name) => {
    this.setState({
      [name]: changeObj.value,
    }, () => this.trataFormulario(name));
  }

  handleKeyDown = (e) => {
    let retorno = null;
    if (e.keyCode === 13) {
      retorno = this.handleSearchButton();
    }
    return retorno;
  }

  handleChangeMascaraFiltro = (changeObj, name) => {
    let mascaraAtual = '';
    switch (changeObj.value) {
      case 1:
        mascaraAtual = 'cpf';
        break;
      case 2:
        mascaraAtual = 'nit';
        break;
      case 3:
        mascaraAtual = 'nb';
        break;
      default:
        mascaraAtual = 'cpf';
        break;
    }
    this.setState({
      [name]: changeObj.value,
      mascara: mascaraAtual,
    }, () => this.trataFormulario(name));
  }

  /**
   * Encaminha para as funcoes que tratam alteracoes em cada campo
   */
  trataFormulario = (campoAlterado) => {
    if (campoAlterado === 'tipoEntidade') {
      this.trataTipoEntidade();
    }
    if (campoAlterado === 'uf') {
      this.trataUf();
    }
    if (campoAlterado === 'participacao') {
      this.trataCombosEntidade();
    }
    if (campoAlterado === 'tipoFiltroPrisma') {
      this.trataFiltroPrisma();
    }
    if (campoAlterado === 'tipoFiltroFilaGet') {
      this.trataFiltroFilaGet();
    }
  }

  trataFiltroPrisma = () => {
    this.setState({ cpf: null, nit: null, numeroBeneficio: null });
  }

  trataFiltroFilaGet = () => {
    this.setState({ idProtocolo: null, pendenteEnvio: null });
  }

  trataUf = () => {
    this.setState({ destinatario: null, 'destinatario-rpps': null });
  }

  trataCombosEntidade = () => {
    this.setState({ tipoEntidade: null, 'destinatario-rpps': null, uf: null });
  }

  trataTipoEntidade = () => {
    this.setState({ 'destinatario-rpps': null, destinatario: null, uf: null });
  }

  trataTipoRegime = () => {
    const tipoEntidadeAposAlteracao = null;
    let destinatarioAposAlteracao = null;
    if (this.state.tipoRegime === 1) {
      destinatarioAposAlteracao = destinoRGPS;
    }
    this.setState(
      {
        tipoEntidade: tipoEntidadeAposAlteracao,
        destinatario: destinatarioAposAlteracao,
      },
      () => {
        this.props.handleChange({
          value: destinatarioAposAlteracao,
          isValid: destinatarioAposAlteracao !== null,
        }, 'destinatario');
      },
    );
  }
  handleSearchButton = () => {
    let filtroPesquisa = {
      cpf: this.state.cpf,
      nit: this.state.nit,
      numeroBeneficio: this.state.numeroBeneficio,
      tipoRequerimento: this.state.tipoRequerimento,
      participacao: this.state.participacao,
      estado: this.state.estado,
      'destinatario-rpps': this.state['destinatario-rpps'],
      filtraExigenciaHomologacao: this.state.filtraExigenciaHomologacao,
      tipoEntidade: this.state.tipoEntidade,
      cliqueiNoBotao: this.state.cliqueiNoBotao,
      filtro: this.state.filtro,
      tipoFiltroFilaGet: this.state.tipoFiltroFilaGet,
      tipoFiltroPrisma: this.state.tipoFiltroPrisma,
      mascara: this.state.mascara,
      dtPrismaInicio: this.state.dtPrismaInicio,
      dtPrismaFim: this.state.dtPrismaFim,
      dtComprevInicio: this.state.dtComprevInicio,
      dtComprevFim: this.state.dtComprevFim,
      tipoPesquisa: this.getTipoConsulta(),
    };
    filtroPesquisa = JSON.stringify(filtroPesquisa);
    sessionStorage.setItem('filtroPesquisa', filtroPesquisa);
    this.setState(
      {
        cliqueiNoBotao: 1,
      },
      () => {
        this.handleChange({
          value: 1,
          isValid: true,
        }, 'cliqueiNoBotao');
      },
    );

    if (!this.props.tipoConsulta) {
      this.handleSearch();
    } else if (this.props.tipoConsulta === 'exigencia' ||
    this.props.tipoConsulta === 'prescricao-exigencia' ||
    this.props.tipoConsulta === 'parecer-medico' ||
    this.props.tipoConsulta === 'cessacao-requerimento' ||
    this.props.tipoConsulta === 'indeferido') {
      this.handleSearch();
    } else if (this.props.tipoConsulta === 'consulta-prisma') {
      this.handleSearchPrisma();
    } else if (this.props.tipoConsulta === 'consulta-filaget') {
      this.handleSearchFilaGet();
    } else if (this.props.tipoConsulta === 'analise' ||
    this.props.tipoConsulta === 'complementar-aposentadoria') {
      this.handleSearchComplementarAposentadoria();
    }
  }

  handleListFilter = () => {
    let listaFiltrada = this.props.list;
    if (this.state.filtraExigenciaHomologacao) {
      listaFiltrada = listaFiltrada.filter((requerimento) => {
        const exigenciasDiferentesHomologacao = requerimento.exigencias
          .filter(exigencia => exigencia.tipo !== (6 || 23));
        if (exigenciasDiferentesHomologacao.length > 0) return true;
        return false;
      });
    }
    this.props.handleChangeList(listaFiltrada);
  }

  handleSearch = () => {
    if (this.props.tipoConsulta === 'exigencia' || this.props.tipoConsulta === 'indeferido') {
      let paramCpf = '';
      if (this.state.cpf) {
        paramCpf = this.state.cpf.toUpperCase();
        if (this.state.cpf.indexOf('_') !== -1) {
          paramCpf = this.state.cpf.toString().replace(/_/g, '');
        }
      }
      this.state.cpf = paramCpf;
    }

    if (this.state.cpf || this.state.tipoRequerimento) {
      if (this.state.tipoEntidade === 2 && !this.state.uf && !this.state['destinatario-rpps']) {
        trataMensagensErro(['Escolha uma UF']);
        return;
      }
      if (this.state.tipoEntidade && !this.state['destinatario-rpps']) {
        trataMensagensErro(['Escolha um filtro de destinatário para a consulta']);
        return;
      }
      if (this.state.tipoEntidade && this.state.uf && !this.state['destinatario-rpps']) {
        trataMensagensErro(['Escolha um filtro de destinatário para a consulta']);
        return;
      }
      this.props.handleSearchFilter(this.state);
    } else {
      trataMensagensErro(['Escolha pelo menos um filtro de CPF ou de Tipo de Requerimento para a consulta']);
    }
  }

  handleSearchPrisma = () => {
    // if (!this.state.filtro) {
    // trataMensagensErro(['É necessário digitar um filtro']);
    // return;
    // }
    if (this.state.cpf) {
      this.state.filtro = this.state.cpf;
    } else if (this.state.nit) {
      this.state.filtro = this.state.nit;
    } else if (this.state.numeroBeneficio) {
      this.state.filtro = this.state.numeroBeneficio;
    }
    this.props.handleSearchFilter(this.state);
  }

  handleSearchFilaGet = () => {
    this.props.handleSearchFilter(this.state);
  }

  handleSearchAnalise = () => {
    // this.state.estado = this.state.estado;
    this.props.handleSearchFilter(this.state);
  }

  handleSearchComplementarAposentadoria = () => {
    this.props.handleSearchFilter(this.state);
  }

  exibirFiltroDestinatario = () => (
    this.state.participacao === 1
  )

  listaFiltradaDestinatarios = () => {
    const listaParticipantes = this.props.destinatarios.filter((item) => {
      if (item.tipoRegimeProprio === this.state.tipoEntidade &&
        ((item.uf && this.state.tipoEntidade === 2) ? item.uf === this.state.uf : true)) {
        return item;
      }
      return null;
    });
    return listaParticipantes;
  }

  carregaUfDosMunicipios = () => {
    const listaUf = [];
    this.props.destinatarios.forEach((item) => {
      if (item.uf && !listaUf.find(itemLista => itemLista.value === item.uf)) {
        listaUf.push({
          label: item.uf,
          value: item.uf,
        });
      }
    });
    listaUf.sort((a, b) => {
      if (a.value > b.value) {
        return 1;
      }
      if (a.value < b.value) {
        return -1;
      }
      return 0;
    });
    return listaUf;
  }

  montaFiltrosDefault = () => (
    <React.Fragment>
      <div className="row">
        <Grid cols="3 3 3 3">
          <Input
            cpf
            integer
            label="CPF"
            mask={Masks.cpf}
            onChange={e => this.handleChange(e, 'cpf')}
            onKeyDown={e => this.handleKeyDown(e, 'cpf')}
            showMask
            value={this.state.cpf}
            validationState="active"
          />
        </Grid>
        <Grid cols="3 3 3 3">
          <Input
            label="Tipo de Requerimento"
            name="tipoRequerimento"
            onChange={e => this.handleChange(e, 'tipoRequerimento')}
            itemList={tipoRequerimentoFilter}
            radio
            value={this.state.tipoRequerimento}
            validationState="active"
            custom
          />
        </Grid>
        {!this.props.auth.checkPermission(['analisar-negocio-sprev']) ?
          <Grid cols="3 3 3 3">
            <Input
              label="Tipo de Participação"
              name="participacao"
              onChange={e => this.handleChange(e, 'participacao')}
              itemList={tipoParticipacao}
              radio
              value={this.state.participacao}
              validationState="active"
              custom
            />
          </Grid>
        : ''}
        <Grid cols="3 3 3 3">
          <Input
            label="Estado do requerimento"
            name="estado"
            onChange={e => this.handleChange(e, 'estado')}
            itemList={tiposEstado}
            value={this.state.estado}
            validationState="active"
            custom
          />
        </Grid>
      </div>
      {this.exibirFiltroDestinatario() ? (
        <ProtectedItem allowedPermissions={this.controleFiltrosAlternativos('destinatario-rpps')}>
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input
                label="Entidade"
                onChange={e => this.handleChange(e, 'tipoEntidade')}
                placeholder="Selecione a entidade"
                value={this.state.tipoEntidade}
                itemList={tipoEntidade}
                custom
                number
              />
            </Grid>
            {this.state.tipoEntidade === 2 ? (
              <Grid cols="4 4 4 4">
                <Input
                  label="UF"
                  onChange={e => this.handleChange(e, 'uf')}
                  placeholder="Selecione a UF"
                  value={this.state.uf}
                  itemList={this.carregaUfDosMunicipios()}
                  custom
                />
              </Grid>
            ) : ''}
            {this.state.tipoEntidade ? (
              <Grid cols="4 4 4 4">
                <Input
                  label="Destinatário"
                  name="destinatario-rpps"
                  onChange={e => this.handleChange(e, 'destinatario-rpps')}
                  placeholder="Selecione o destinatário"
                  value={this.state['destinatario-rpps']}
                  itemList={this.listaFiltradaDestinatarios()}
                  custom
                />
              </Grid>
            ) : ''}
          </div>
        </ProtectedItem>
      ) : ''}
    </React.Fragment>
  )

  montaFiltrosCessacao = () => (
    <div className="row">
      <Grid cols="2 2 2 2">
        <Input
          cpf
          integer
          label="CPF"
          mask={Masks.cpf}
          onChange={e => this.handleChange(e, 'cpf')}
          onKeyDown={e => this.handleKeyDown(e, 'cpf')}
          showMask
          value={this.state.cpf}
          validationState="active"
        />
      </Grid>
      <Grid cols="3 3 3 3">
        <Input
          label="Tipo de Requerimento"
          name="tipoRequerimento"
          onChange={e => this.handleChange(e, 'tipoRequerimento')}
          itemList={tipoRequerimentoFilter}
          radio
          value={this.state.tipoRequerimento}
          validationState="active"
          custom
        />
      </Grid>
    </div>
  )

  // handleBlurCpfExigencia = () => {
  //   const { cpf } = { ...this.state };
  //   let paramCpf = '';
  //   if (cpf) {
  //     paramCpf = cpf.toUpperCase();
  //     if (cpf.indexOf('_') !== -1) {
  //       paramCpf = cpf.toString().replace(/_/g, '');
  //     }
  //   }
  //   this.setState({ cpf: paramCpf });
  // }

  montaFiltrosExigencia = () => (
    <div className="row">
      <Grid cols="2 2 2 2">
        <Input
          cpf
          label="CPF"
          filtroExigencia
          mask={Masks.cpfFiltroExigencia}
          onChange={e => this.handleChange(e, 'cpf')}
          // onBlur={e => this.handleBlurCpfExigencia(e, 'cpf')}
          onKeyDown={e => this.handleKeyDown(e, 'cpf')}
          showMask
          value={this.state.cpf}
          validationState="active"
        />
      </Grid>
      <Grid cols="3 3 3 3">
        <Input
          label="Tipo de Requerimento"
          name="tipoRequerimento"
          onChange={e => this.handleChange(e, 'tipoRequerimento')}
          itemList={tipoRequerimentoFilter}
          radio
          value={this.state.tipoRequerimento}
          validationState="active"
          custom
        />
      </Grid>
    </div>
  )

  montaFiltrosAnalise = () => (
    <div className="row">
      <Grid cols="4 4 4 4">
        <Input
          label="Estado do requerimento"
          name="estado"
          onChange={e => this.handleChange(e, 'estado')}
          itemList={tiposEstadoAnalise}
          value={this.state.estado}
          validationState="active"
          custom
        />
      </Grid>
    </div>
  )

  montaFiltrosComplementarAposentadoria = () => (
    <div className="row">
      <Grid cols="2 2 2 2">
        <Input
          cpf
          integer
          label="CPF"
          mask={Masks.cpf}
          onChange={e => this.handleChange(e, 'cpf')}
          onKeyDown={e => this.handleKeyDown(e, 'cpf')}
          showMask
          value={this.state.cpf}
          validationState="active"
        />
      </Grid>
    </div>
  )

  montaFiltrosExigenciaParecerMedico = () => (
    <div className="row">
      <Grid cols="2 2 2 2">
        <Input
          cpf
          integer
          label="CPF"
          mask={Masks.cpf}
          onChange={e => this.handleChange(e, 'cpf')}
          onKeyDown={e => this.handleKeyDown(e, 'cpf')}
          showMask
          value={this.state.cpf}
          validationState="active"
        />
      </Grid>
      <Grid cols="3 3 3 3">
        <Input
          label="Tipo de Requerimento"
          name="tipoRequerimento"
          onChange={e => this.handleChange(e, 'tipoRequerimento')}
          itemList={tipoRequerimentoFilter}
          radio
          value={this.state.tipoRequerimento}
          validationState="active"
        />
      </Grid>
      <Grid cols="3 3 3 3">
        <Input
          label="Estado do requerimento"
          name="estado"
          onChange={e => this.handleChange(e, 'estado')}
          itemList={tiposEstadoParecerMedico}
          value={this.state.estado}
          validationState="active"
          custom
        />
      </Grid>
    </div>
  )

  montaFiltrosPrisma = () => (
    <React.Fragment>
      <div className="row">
        <Grid cols="3 3 3 3">
          <Input
            label="Pesquisar por"
            name="tipoFiltroPrisma"
            onChange={e => this.handleChangeMascaraFiltro(e, 'tipoFiltroPrisma')}
            itemList={prismaFilter}
            radio
            value={this.state.tipoFiltroPrisma}
            validationState="active"
          />
        </Grid>
        {this.state.mascara === 'cpf' ?
          <Grid cols="2 2 2 2">
            <Input
              integer
              label="Filtro"
              onChange={e => this.handleChangeMascaraFiltro(e, 'cpf')}
              showMask
              value={this.state.cpf}
              validationState="active"
              mask={Masks.cpf}
            />
          </Grid>
        : '' }
        {this.state.mascara === 'nit' ?
          <Grid cols="2 2 2 2">
            <Input
              integer
              label="Filtro"
              onChange={e => this.handleChangeMascaraFiltro(e, 'nit')}
              showMask
              value={this.state.nit}
              validationState="active"
              mask={Masks.nit}
            />
          </Grid>
        : '' }
        {this.state.mascara === 'nb' ?
          <Grid cols="2 2 2 2">
            <Input
              integer
              label="Filtro"
              maxlength="15"
              onChange={e => this.handleChange(e, 'numeroBeneficio')}
              showMask
              value={this.state.numeroBeneficio}
              validationState="active"
            />
          </Grid>
        : '' }
      </div>
      <div className="row">
        <Grid cols="6 6 6 6">
          <Input
            mask={Masks.date}
            label="Início recebimento PRISMA"
            onChange={e => this.handleChange(e, 'dtPrismaInicio')}
            showMask
            value={this.state.dtPrismaInicio}
            validationState="active"
          />
        </Grid>
        <Grid cols="6 6 6 6">
          <Input
            mask={Masks.date}
            label="Fim recebimento PRISMA"
            onChange={e => this.handleChange(e, 'dtPrismaFim')}
            showMask
            value={this.state.dtPrismaFim}
            validationState="active"
          />
        </Grid>
      </div>
      <div className="row">
        <Grid cols="6 6 6 6">
          <Input
            mask={Masks.date}
            label="Início envio COMPREV"
            onChange={e => this.handleChange(e, 'dtComprevInicio')}
            showMask
            value={this.state.dtComprevInicio}
            validationState="active"
          />
        </Grid>
        <Grid cols="6 6 6 6">
          <Input
            mask={Masks.date}
            label="Fim envio COMPREV"
            onChange={e => this.handleChange(e, 'dtComprevFim')}
            showMask
            value={this.state.dtComprevFim}
            validationState="active"
          />
        </Grid>
      </div>
      <div className="row">
        <Grid cols="6 6 6 6">
          <Input
            integer
            maxlength="2"
            label="Número Espécie"
            onChange={e => this.handleChange(e, 'especieBeneficio')}
            showMask
            value={this.state.especieBeneficio}
            validationState="active"
          />
        </Grid>
      </div>
    </React.Fragment>
  )

  montaFiltrosGet = () => (
    <React.Fragment>
      <div className="row">
        <Grid cols="2 2 2">
          <Input
            label="Pesquisar por"
            name="tipoFiltroFilaGet"
            itemList={filaGetFilter}
            radio
            value={this.state.tipoFiltroFilaGet}
            validationState="active"
          />
        </Grid>
        <Grid cols="6 6 6 6">
          <Input
            label="Protocolo"
            onChange={e => this.handleChange(e, 'idProtocolo')}
            value={this.state.idProtocolo}
            validationState="active"
            consultaFilaGet
          />
        </Grid>
        <Grid cols="3 3 3 3">
          <Input
            label="Pendente Envio GET"
            name="pendenteEnvio"
            onChange={e => this.handleChange(e, 'pendenteEnvio')}
            itemList={pendenteEnvio}
            value={this.state.pendenteEnvio}
            validationState="active"
            custom
          />
        </Grid>
      </div>
      <div className="row">
        <Grid cols="2 2 2" />
        <Grid cols="6 6 6 6">
          <Input
            label="Retorno"
            onChange={e => this.handleChange(e, 'mensagemRetorno')}
            value={this.state.mensagemRetorno}
            validationState="active"
            consultaFilaGet
          />
        </Grid>
      </div>
      <div className="row">
        <Grid cols="2 2 2" />
        <Grid cols="6 6 6 6">
          <Input
            label="Body Envio"
            onChange={e => this.handleChange(e, 'bodyEnvio')}
            value={this.state.bodyEnvio}
            validationState="active"
            consultaFilaGet
          />
        </Grid>
      </div>
    </React.Fragment>
  )

  montaFiltros = () => {
    if (!this.props.tipoConsulta) {
      return this.montaFiltrosDefault();
    } else if (this.props.tipoConsulta === 'exigencia') {
      return this.montaFiltrosExigencia();
    } else if (this.props.tipoConsulta === 'parecer-medico') {
      return this.montaFiltrosExigenciaParecerMedico();
    } else if (this.props.tipoConsulta === 'prescricao-exigencia') {
      return this.montaFiltrosExigencia();
    } else if (this.props.tipoConsulta === 'cessacao-requerimento') {
      return this.montaFiltrosCessacao();
    } else if (this.props.tipoConsulta === 'consulta-prisma') {
      return this.montaFiltrosPrisma();
    } else if (this.props.tipoConsulta === 'consulta-filaget') {
      return this.montaFiltrosGet();
    } else if (this.props.tipoConsulta === 'indeferido') {
      return this.montaFiltrosExigencia();
    } else if (this.props.tipoConsulta === 'analise') {
      return this.montaFiltrosAnalise();
    } else if (this.props.tipoConsulta === 'complementar-aposentadoria') {
      return this.montaFiltrosComplementarAposentadoria();
    }
    return null;
  }

  render() {
    const filtrosPesquisa = this.montaFiltros();
    if (!filtrosPesquisa) {
      return null;
    }
    return (
      <DtpAccordionGroup>
        <DtpAccordionPanel
          headingId="pesquisa"
          panelId="filtro-pesquisa"
          icon="ico-filter"
          title="Filtro de Pesquisa"
        >
          {filtrosPesquisa}
          <div className="row">
            <Button
              className="dtp-primary right"
              title="Pesquisar"
              onClick={() => this.handleSearchButton()}
              hint="Pesquisar de acordo com o filtro aplicado"
            />
          </div>
        </DtpAccordionPanel>
      </DtpAccordionGroup>
    );
  }
}

FiltroPesquisa.propTypes = {
  destinatarios: PropTypes.arrayOf().isRequired,
  handleChangeList: PropTypes.func,
  handleSearchFilter: PropTypes.func,
  list: PropTypes.array,
  tipoConsulta: PropTypes.string,
  auth: PropTypes.objectOf(PropTypes.object).isRequired,
}.isRequired;

export default FiltroPesquisa;



// WEBPACK FOOTER //
// ./src/pages/consultas/FiltroPesquisa.jsx